export const language = {
    dialog: {
        settings: {
            header: "إعدادات",
            items: {
                motion: {
                    label: "انخفاض الحركة",
                },
                contrast: {
                    label: "وضع التباين العاليs",
                },
            },
        },
    },
    footer: {
        copyright: {
            label: "كل الحقوق محفوظة",
        },
    },
    sidebar: {
        sitemap: {
            header: "خريطة",
        },
    },
};
